/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BillingDetails
 */
export interface BillingDetails {
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    line1?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    zipCode?: string;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    state?: string;
}

/**
 * Check if a given object implements the BillingDetails interface.
 */
export function instanceOfBillingDetails(value: object): value is BillingDetails {
    return true;
}

export function BillingDetailsFromJSON(json: any): BillingDetails {
    return BillingDetailsFromJSONTyped(json, false);
}

export function BillingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'city': json['city'] == null ? undefined : json['city'],
        'country': json['country'] == null ? undefined : json['country'],
        'line1': json['line1'] == null ? undefined : json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'state': json['state'] == null ? undefined : json['state'],
    };
}

export function BillingDetailsToJSON(json: any): BillingDetails {
    return BillingDetailsToJSONTyped(json, false);
}

export function BillingDetailsToJSONTyped(value?: BillingDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'city': value['city'],
        'country': value['country'],
        'line1': value['line1'],
        'line2': value['line2'],
        'zipCode': value['zipCode'],
        'state': value['state'],
    };
}

